import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DeliveryInformationsCard from './DeliveryInformationsCard';

const MergeConfirmationDialog = ({
  open,
  handleClose,
  handleClickMerge,
  numberOfCommandsToMerge,
  selectedCommandInformations
}) => (
  <div>
    <Dialog open={open} onClose={handleClose}>
      {open && (
        <>
          <DialogTitle>Fusion des commandes</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vous êtes sur le point de fusionner{' '}
              <strong>{numberOfCommandsToMerge}</strong> commandes. <br /> Vos
              commandes utiliseront les informations suivantes :
            </DialogContentText>
            <DeliveryInformationsCard command={selectedCommandInformations} />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleClose()}
              color="secondary"
              variant="contained"
            >
              Annuler
            </Button>
            <Button
              onClick={() => handleClickMerge()}
              color="primary"
              variant="contained"
              autoFocus
            >
              Confirmer
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  </div>
);

MergeConfirmationDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleClickMerge: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  numberOfCommandsToMerge: PropTypes.number.isRequired,
  selectedCommandInformations: PropTypes.object
};

export default MergeConfirmationDialog;
